const Account = {
  init() {
    if (!($('.account').length > 0)) return;
    $('.delete-confirm-expander').click(this.handleDeleteConfirmExpanderClick.bind(this));
    $('.upcoming-badge-notification-section').click(this.handleBadgeToggleClick);
  },

  handleDeleteConfirmExpanderClick() {
    $('.delete-stage-1').hide();
    $('.delete-confirm').slideDown();
  },

  handleBadgeToggleClick() {
    $('.upcoming-badge-section').slideToggle();
  }
};

$(document).ready(()=> {
  Account.init();
});
